module.exports = __webpack_public_path__ + "static/Q2Answer4_saharadessert_wishmas-ccbda473680dfa0db87e742480fcca53.jpg";